import { createSlice } from '@reduxjs/toolkit';
import { generateReduxKeys } from '../../utils';

const initialState = generateReduxKeys({
  notification: 'default',
});

const preferenceSlice = createSlice({
  name: 'preference',
  initialState,
  reducers: {
    setNotificationSound: (state, action) => {
      localStorage.setItem('notification', JSON.stringify(action.payload));
      state.notification = action.payload;
    },
  },
});

export const { setNotificationSound } = preferenceSlice.actions;

export default preferenceSlice.reducer;
